<div
  class="card card-success"
>
  <div style="padding-top: 13px" class="card-body">
    <div class="row">
      <div class="col-md-1">
        <i class="fa fa-user fa-3x"></i>
      </div>
      <div class="col-md-11">
        <div class="row">
          <div style="font-size: 18px; text-decoration: underline;">
            {{ results.name }} ({{ results.dob }})
          </div>
        </div>
        <div class="row">
          <input
            type="file"
            id="{{ 'myFile' }}"
            name="{{ 'myFile'}}"
            (change)="handleFileInput($event.target.files)"
          />
        </div>
        <div
          class="help-block has-error validationMessage"
          id="{{ 'error' }}"
          hidden
        >
          Only PDFs
        </div>
        <div class="row" style="padding-top: 15px">
          <br /><button
          (click)="uploadForm(results.payrollAccount.toString())"
          class="form-group btn btn-primary"
          [disabled]="true"
          id="uploadBtn"
        >
          Upload Form
        </button>
          <div *ngIf="upload">
            <i class="fa fa-spinner fa-spin fa-4x"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
